if ($("div[data-testid='boxCustomerCenterMenu']").length) {
    $("div[data-testid='boxCustomerCenterMenu'] ul li:not(:first-child):not(.logout) a").each(function () {
        const link = $(this).attr("href") || "";
        const fallbackImgPath = "https://cdn.myshoptet.com/prj/dist/master/cms/templates/frontend_templates/00/img/folder.svg";
        const clientLink = link
            .replace(/^\/+|\/+$/g, "")
            .split("/")
            .filter(Boolean)
            .pop();

        if (!clientLink) {
            return;
        }

        const imgPath = `/user/documents/upload/sablona/klient/${clientLink}.svg`;
        $(this).prepend(`<img src="${imgPath}" alt="${clientLink}" onerror="this.onerror=null;this.src='${fallbackImgPath}';">`);
    });
}

